import React, { useState, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { Alert } from "../";
import { AllWidgets } from "./";
import { DeviceSection } from "../../context/DeviceContext";
import { deviceJoin, deviceWidgetsJoinedApi, zoneWidgets } from "../../api";
import { setDeviceWidgetsJoined, setZoneWidgets } from "../../redux";
import { withRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";
const AllDeviceComp = (props) => {
  const { t } = useTranslation();
  const token = Cookies.get("token");
  const dispatch = useDispatch();
  const { ShowHideDeviceFunction } = useContext(DeviceSection);
  const deviceWidgets = useSelector((state) => state.deviceWidgets);
  const dashboardZones = useSelector(
    (state) => state.dashboardZones.dashboardZones
  );
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });

  const deviceJoinFunc = () => {
    const formData = new FormData();
    const serial = deviceWidgets[0]["serial"];
    formData.append("serial", serial);
    formData.append("zone", dashboardZones[0]["id"]);
    deviceJoin(formData, token)
      .then(() => {
        const data = new FormData();
        data.append("serial", serial);
        deviceWidgetsJoinedApi(data, token)
          .then((res) => {
            dispatch(setDeviceWidgetsJoined(res.data.data));
            ShowHideDeviceFunction("widgetsJoined");
            // console.log(res)
            const zoneId = new FormData();
            zoneId.append("zone", dashboardZones[0]["id"]);
            zoneWidgets(zoneId, token)
              .then((res) => {
                dispatch(setZoneWidgets(res.data.data));
              })
              .catch((err) => {
                if (err.response.status === 403) {
                  Cookies.remove("token");
                  props.history.push("/login");
                  setShowAlert((prevState) => ({
                    ...prevState,
                    show: true,
                    message: t("خطایی رخ داده است . لطفا مجددا امتحان کنید."),
                    type: "Error",
                  }));
                  setTimeout(() => {
                    setShowAlert((prevState) => ({
                      ...prevState,
                      show: false,
                    }));
                  }, 2000);
                }
              });
          })
          .catch((err) => {
            if (err.response.status === 403) {
              Cookies.remove("token");
              props.history.push("/login");
              setShowAlert((prevState) => ({
                ...prevState,
                show: true,
                message: t("خطایی رخ داده است . لطفا مجددا امتحان کنید."),
                type: "Error",
              }));
              setTimeout(() => {
                setShowAlert((prevState) => ({
                  ...prevState,
                  show: false,
                }));
              }, 2000);
            }
          });
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
        } else {
          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            message: t("این دستگاه قبلا اضافه شده است."),
            type: "Error",
          }));
          setTimeout(() => {
            setShowAlert((prevState) => ({
              ...prevState,
              show: false,
            }));
          }, 3000);
        }
      });
  };

  return (
    <>
      <div
        className="d-flex flex-wrap justify-content-between"
        style={{ maxHeight: "65vh", overflow: "auto" }}
      >
        {deviceWidgets?.map((widget, index) => {
          return <AllWidgets key={index} widget={widget} num={index + 1} />;
        })}
      </div>
      <div className="d-flex flex-wrap justify-content-center mt-5">
        <button
          type="submit"
          className="border-0 bg-transparent mx-3 d-flex justify-content-center align-items-center flex-column text-center"
          onClick={deviceJoinFunc}
        >
          <span className="profileAddUser bg-white d-block icon-ok cursor"></span>
          <small className="fn12 mt-1">{t("تائید")}</small>
        </button>
        <div
          className="mx-3 d-flex justify-content-center align-items-center flex-column text-center"
          onClick={() => ShowHideDeviceFunction("scanDevice")}
        >
          <span className="profileAddUser bg-white d-block icon-left-1 cursor"></span>
          <small className="fn12 mt-1">{t("بازگشت")}</small>
        </div>
      </div>
      {showAlert.show && (
        <Alert message={showAlert.message} type={showAlert.type} />
      )}
    </>
  );
};

const AllDevice = withRouter(AllDeviceComp);

export { AllDevice };
